import { useSelector } from 'react-redux';

export const COLORS = {
  colorPrimary: '#EB3D26',
  colorInfo: '#EB3D26',
};

export const selectedDateFormat = 'DD/MM/YYYY';
export const defaultDateFormat = 'MM/DD/YYYY';
